export { default as GradientAvatar, default } from './GradientAvatar';
